import { createSlice } from "@reduxjs/toolkit";
import { addStoryCommentAPI, communityStoriesAPI,flagStoryAPI,storiesUpVoteAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const communityStoriesSlice = createSlice({
  name: "communityStories",
  initialState: data,
  reducers: {
    communityStoriesSlice(state) {
      state.isLoading = true;
    },
    communityStoriesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    manageStorieSliceSuccess(state, _action) {
      state.isLoading = false;
      state.message = null;
    },
    communityStoriesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    communityStoriesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const communityStoriesHandler = (id:any,role:any,page:number,size:number) => async (dispatch: any) => {
  try {
    dispatch(communityStoriesAction.communityStoriesSlice());
    const response: any = await communityStoriesAPI(id,role,page,size);
    dispatch(communityStoriesAction.communityStoriesSliceSuccess(response));
  } catch (e: any) {
    dispatch(communityStoriesAction.communityStoriesSliceFailure(e?.response?.data?.message));
    dispatch(communityStoriesAction.communityStoriesSliceReset());
  }
};
export const storieLikeHandler = (review_id:string) => async (dispatch: any) => {
  try {
    dispatch(communityStoriesAction.communityStoriesSlice());
    const response: any = await storiesUpVoteAPI(review_id);
    dispatch(communityStoriesAction.manageStorieSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(communityStoriesAction.communityStoriesSliceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const storieAddCommentHandler = (review_id:string,body:any) => async (dispatch: any) => {
  try {
    dispatch(communityStoriesAction.communityStoriesSlice());
    const response: any = await addStoryCommentAPI(review_id,body);
    dispatch(communityStoriesAction.manageStorieSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(communityStoriesAction.communityStoriesSliceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const flagStoryHandler = (review_id:string,body:any) => async (dispatch: any) => {
  try {
    dispatch(communityStoriesAction.communityStoriesSlice());
    const response: any = await flagStoryAPI(review_id,body);
    dispatch(communityStoriesAction.manageStorieSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(communityStoriesAction.communityStoriesSliceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default communityStoriesSlice.reducer;
export const communityStoriesAction = communityStoriesSlice.actions;
